import { render } from "./PunchOut.vue?vue&type=template&id=05c10a0d"
import script from "./PunchOut.vue?vue&type=script&lang=js"
export * from "./PunchOut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__